<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickUpdate)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="site_name" name="site_name" rules="required" v-slot="{ errors }">
              <small class="label">Manufacturing site name</small>
              <vs-input :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="site_name" class="w-full required" label="" v-model="form.site_name"/>

            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="address_line_1" name="address_line_1" rules="required" v-slot="{ errors }">
              <small class="label">Manufacturing Address Line 1</small>
              <vs-input name="address_line1"  class="w-full required" label="" v-model="form.address_line1" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="address_line_2" name="address_line_2" rules="" v-slot="{ errors }">
              <small class="label">Manufacturing Address Line 2</small>
              <vs-input  class="w-full required" label="" v-model="form.address_line2" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="address_line_3" name="address_line_3" rules="" v-slot="{ errors }">
              <small class="label">Manufacturing Address Line 3</small>
              <vs-input  class="w-full required" label="" v-model="form.address_line3" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="town" name="town" rules="required" v-slot="{ errors }">
              <small class="label">Manufacturing Site Town State</small>
              <vs-input  class="w-full required" label="" v-model="form.address_town_state" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="address_post_code" name="address_post_code" rules="required|max:10" v-slot="{ errors }">
              <small class="label">Manufacturing Site Postcode</small>
              <vs-input name="address_post_code"  class="w-full required" label="" v-model="form.address_post_code" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full">
            <ValidationProvider vid="address_country" name="address_country" rules="required" v-slot="{ errors }">
              <small class="label">Country</small>
              <v-select :filter-by="myFilter"  :clearable="false" name="address_country" placeholder="" label="name" v-model="form.address_country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template v-slot:option="option">
                  <span>{{option.name}} </span>
                </template>
              </v-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <ValidationProvider vid="site_telephone_code" name="site_telephone_code" rules="required" v-slot="{ errors }">
                  <small class="label">Country Code</small>
                  <v-select label="isd_code" :filter-by="myFilter" :clearable="false" placeholder="code" v-model="form.country_code_site_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.isd_code}} - {{option.name}} </span>
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-2/3">
                <ValidationProvider vid="site_telephone" name="site_telephone" rules="required|tel|max:15" v-slot="{ errors }">
                  <small class="label">Telephone Number</small>
                  <vs-input name="site_telephone"  class="w-full required" label="" v-model="form.site_telephone" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <ValidationProvider vid="site_fax_code" name="site_fax_code" rules="" v-slot="{ errors }">
                  <small class="label">Country Code</small>
                  <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code" v-model="form.country_code_site_fax" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.isd_code}} - {{option.name}} </span>
                    </template>
                  </v-select>
                </ValidationProvider>
              </div>
              <div class="vx-col w-2/3">
                <ValidationProvider vid="site_fax" name="site_fax" rules="fax|max:15" v-slot="{ errors }">
                  <small class="label">Fax No</small>
                  <vs-input name="site_fax"  class="w-full required" label="" v-model="form.site_fax" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full">
            <ValidationProvider vid="email_address" name="Email Address" rules="email" v-slot="{ errors }">
              <small class="label">Email Address</small>
              <vs-input type="email"  class="w-full required" label="" v-model="form.site_email" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <small class="label">Website Address</small>
            <vs-input  class="w-full required" label="" v-model="form.site_website"/>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <small class="label">Additional Info</small>
            <vs-textarea v-model="form.site_additional_info" />
          </div>
        </div>

        <vx-card titleColor="#736F6E" title="Accreditation Comments" class="my-8" no-shadow>
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col md:w-full md:mb-0">
              <ValidationProvider vid="is_GFSI_accreditation" name="is_GFSI_accreditation" rules="" v-slot="{ errors }">
                <small class="label">Do you have GFSI Accreditation?</small>
                <vs-switch v-model="form.is_GFSI_accreditation" icon-pack="feather" vs-icon-on="icon-check-circle"
                           vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
          </div>

          <vs-row vs-w="12" class="mt-8" v-if="form.is_GFSI_accreditation">
            <vs-col v-for="(gfsi, index_gfsi) in form.GFSIs" :key="index_gfsi"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="6" vs-sm="6" vs-xs="12"
                    class="px-4 pb-4">
              <vx-card-custom :cardBorder="true" no-shadow :remove-card-action="form.GFSIs.length > 1"  v-on:remove="removeGfsi(index_gfsi)" :collapse-action="false">

                <div class="vx-row mb-2">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider :vid="index_gfsi+'gfsi_name'" :name="index_gfsi+'gfsi_name'" rules="required" v-slot="{ errors }">
                      <small class="label">Name</small>
                      <v-select :closeOnSelect="true" v-model="gfsi.name" :options="['BRC', 'FSSC 22000', 'IFS', 'SQF']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>


                <div class="vx-row mb-2">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider :vid="index_gfsi+'gfsi_grade'" :name="index_gfsi+'gfsi_grade'" rules="required" v-slot="{ errors }">
                      <small class="label">Accreditation Grade</small>
                      <vs-input  class="w-full required" label="" v-model="gfsi.grade" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider :vid="index_gfsi+'gfsi_body'" :name="index_gfsi+'gfsi_body'" rules="required" v-slot="{ errors }">
                      <small class="label">Accreditation Body</small>
                      <vs-input  class="w-full required" label="" v-model="gfsi.body" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-2">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider :vid="index_gfsi+'gfsi_expiry'" :name="index_gfsi+'gfsi_expiry'" rules="required" v-slot="{ errors }">
                      <small class="label">Accreditation Expiration Date</small>
                      <flat-pickr class="w-full hidden" :config="{ dateFormat: 'd/m/Y'}" v-model="gfsi.expiry" placeholder="Choose Date"
                      />
                      <flat-pickr
                        class="w-full"
                        :config="{ dateFormat: 'd/m/Y'}"
                        v-model="gfsi.expiry"
                        placeholder="Choose Date"
                      />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="" name="" rules="" v-slot="{ errors }">
                      <small class="label">Details of {{ gfsi.name }}  (file)</small>
                    </ValidationProvider>
                    <file-uploader-not-required
                      v-on:onSetFileName="value => gfsi.file = value"
                      v-on:onClickFileRemove="gfsi.file = null"
                      :file="gfsi.file"
                      :condition="true"
                    />
                  </div>
                </div>

              </vx-card-custom>
            </vs-col>
          </vs-row>
          <vs-button v-if="form.is_GFSI_accreditation" class="mt-4 mb-4 ml-4" @click="addGfsi" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add new gfsi</vs-button>
        </vx-card>

        <vx-card titleColor="#736F6E" title="Other Accreditation" class="my-8" no-shadow>
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col md:w-full md:mb-0">
              <ValidationProvider vid="is_other_accreditations" name="is_other_accreditations" rules="" v-slot="{ errors }">
                <small class="label">Do you have any other accreditation (including ISO)?</small>
                <vs-switch v-model="form.is_other_accreditations" icon-pack="feather" vs-icon-on="icon-check-circle"
                           vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
          </div>

          <vs-row vs-w="12" class="mt-8" v-if="form.is_other_accreditations">
            <vs-col v-for="(other, index) in form.other_accreditations" :key="index"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="6" vs-sm="6" vs-xs="12"
                    class="px-4 pb-4">
              <vx-card-custom :cardBorder="true" no-shadow :remove-card-action="form.other_accreditations.length > 1"  v-on:remove="removeOther(index)" :collapse-action="false">

                <div class="vx-row mb-2">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider :vid="index+'other_name'" :name="index+'other_name'" rules="required" v-slot="{ errors }">
                      <small class="label">Name</small>
                      <vs-input  class="w-full required" label="" v-model="other.name" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>


                <div class="vx-row mb-2">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider :vid="index+'other_grade'" :name="index+'other_grade'" rules="required" v-slot="{ errors }">
                      <small class="label">Accreditation Grade</small>
                      <vs-input  class="w-full required" label="" v-model="other.grade" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider :vid="index+'other_body'" :name="index+'other_body'" rules="required" v-slot="{ errors }">
                      <small class="label">Accreditation Body</small>
                      <vs-input  class="w-full required" label="" v-model="other.body" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-2">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider :vid="index+'other_expiry'" :name="index+'other_expiry'" rules="required" v-slot="{ errors }">
                      <small class="label">Accreditation Expiration Date</small>
                      <flat-pickr class="w-full hidden" :config="{ dateFormat: 'd/m/Y'}" v-model="other.expiry" placeholder="Choose Date"
                      />
                      <flat-pickr
                        class="w-full"
                        :config="{ dateFormat: 'd/m/Y'}"
                        v-model="other.expiry"
                        placeholder="Choose Date"
                      />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="" name="" rules="" v-slot="{ errors }">
                      <small class="label">Details of BRC  (file)</small>
                    </ValidationProvider>
                    <file-uploader-not-required
                      v-on:onSetFileName="value => other.file = value"
                      v-on:onClickFileRemove="other.file = null"
                      :file="other.file"
                      :condition="true"
                    />
                  </div>
                </div>

              </vx-card-custom>
            </vs-col>
          </vs-row>
          <vs-button v-if="form.is_other_accreditations" class="mt-4 mb-4 ml-4" @click="addOther" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add new accreditation</vs-button>
        </vx-card>
        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>

  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: "SupplierManufacturingHome",
    components: {
      'v-select': vSelect,
      flatPickr
    },
    data() {
      return {
        form: {
          GFSIs: [],
          other_accreditations: [],
          is_GFSI_accreditation: false,
          is_other_accreditations: false
        },
        old_gfsi_value: null,
        id: null,
        countryCodes: []
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      async onClickNext() {
        this.$emit('notify', 1)
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          if (!this.form.is_GFSI_accreditation) {
            this.form.GFSIs = []
          }
          if (!this.form.is_other_accreditations) {
            this.form.other_accreditations = []
          }
          const data = (await SupplierManufactureRepository.updateManufactureDetails(this.id, this.form))
          this.showSuccessMessage('Manufacture Site Details Updated!')
          if (this.old_gfsi_value === this.form.is_GFSI_accreditation) {
            this.onClickNext()
          } else {
            this.$router.go()
          }
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async loadCountrCode() {
        const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
        this.countryCodes =  data
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
      addGfsi() {
        this.form.GFSIs.push({name: '', grade: '', body: '', expiry: '', file: ''})
      },
      removeGfsi(index) {
        this.form.GFSIs.splice(index, 1)
      },

      addOther() {
        this.form.other_accreditations.push({name: '', grade: '', body: '', expiry: '', file: ''})
      },
      removeOther(index) {
        this.form.other_accreditations.splice(index, 1)
      }
    },
    async mounted() {
      this.$vs.loading()
      this.id = this.$route.params.id
      const {data} = (await SupplierManufactureRepository.getManufactureDetails(this.id)).data
      this.form = data
      this.form.GFSIs.length === 0 ? this.addGfsi() : this.form.GFSIs
      this.form.other_accreditations.length === 0 ? this.addOther() : this.form.other_accreditations
      this.old_gfsi_value = this.form.is_GFSI_accreditation
      this.loadCountrCode()
      this.$vs.loading.close()
    }

  }
</script>

<style scoped>

</style>
